export enum TabsKeys {
    sources = 'sources',
    feeds = 'feeds',
    favourites = 'favourites'
}